import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {Body} from "@khanacademy/wonder-blocks-typography";

/**
 * A "list-item-text" is the element within a "list-item" that contains the
 * actual content of the item. We just render it as a <p> here, but we adjust
 * the bottom margin to be smaller than that of paragraph blocks so that list
 * items appear grouped closer together.
 */
export default function ListItemTextNode(
    props: RenderElementProps,
): React.ReactElement {
    const {attributes, children} = props;

    return (
        <Body {...attributes} tag="p" style={styles.listItemText}>
            {children}
        </Body>
    );
}

const styles = StyleSheet.create({
    listItemText: {
        marginBlockStart: 0,
        marginBlockEnd: spacing.small_12,
    },
});
